import { render } from "./ShowCaracterisation.vue?vue&type=template&id=84826d2a"
import script from "./ShowCaracterisation.vue?vue&type=script&lang=js"
export * from "./ShowCaracterisation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__